import * as React from 'react'
import {ViewConfig, RouteChildren} from '@eda.yandex/web-router'
import {RouterEnv} from 'admin/types'

class CTTPage extends React.Component {
  render () {
    return <RouteChildren />
  }
}

const viewConfig: ViewConfig<RouterEnv> = {
  displayName: 'CTT',
  Component: CTTPage,
  async controller (_route, env) {
    env.store.ui.setGlobalLoader(true)
    try {
      await env.store.ctt.initialize()
    } finally {
      env.store.ui.setGlobalLoader(false)
    }
  }
}

export default viewConfig
